import {
    LayoutDashboard,
    Package,
    ShoppingCart,
    Users,
    Boxes,
    Settings,
    Store,
    Calculator,
    AlertCircle,
    Crown
} from "lucide-react"
import type React from "react"

export interface SubLink {
    label: string
    href: string
    allowedRoles?: string[] // Adding allowedRoles to SubLink
}

export interface Links {
    label: string
    href?: string
    icon: React.ReactNode
    sublinks?: SubLink[]
    isSection?: boolean
    allowedRoles?: string[]
    isPro?: boolean // Add isPro property to mark premium features
    isClickable?: boolean // Add isClickable property to control if the link can be clicked
}

export const links: Links[] = [
    {
        label: "Accueil",
        href: "/admin",
        icon: <LayoutDashboard className="text-neutral-700 dark:text-neutral-200 h-5 w-5 flex-shrink-0" />,
        allowedRoles: ["admin", "manager"],
        isClickable: true,
    },
    {
        label: "Mon Catalogue",
        icon: <Package className="text-neutral-700 dark:text-neutral-200 h-5 w-5 flex-shrink-0" />,
        isSection: true,
        allowedRoles: ["admin", "manager"],
        isClickable: true,
        sublinks: [
            {
                label: "Produits",
                href: "/admin/entities/products",
                allowedRoles: ["admin", "manager"],
            },
            {
                label: "Categorie",
                href: "/admin/entities/category",
                allowedRoles: ["admin", "manager"],
            },
            {
                label: "Sous Categorie",
                href: "/admin/entities/subcategory",
                allowedRoles: ["admin", "manager"],
            },
            {
                label: "Marques",
                href: "/admin/entities/brand",
                allowedRoles: ["admin", "manager"],
            },
            {
                label: "Livraisons",
                href: "/admin/entities/shipping",
                allowedRoles: ["admin", "manager"],
            },
            {
                label: "Clients",
                href: "/admin/entities/clients",
                allowedRoles: ["admin", "manager"],
            },
        ],
    },
    {
        label: "Ma caisse",
        icon: <ShoppingCart className="text-neutral-700 dark:text-neutral-200 h-5 w-5 flex-shrink-0" />,
        isSection: true,
        allowedRoles: ["admin", "manager"],
        isClickable: true,
        sublinks: [
            {
                label: "Point de vente",
                href: "/admin/cash-register/pos",
                allowedRoles: ["admin", "manager"],
            },
            {
                label: "Remboursement",
                href: "/admin/cash-register/refunds",
                allowedRoles: ["admin", "manager"],
            },
            {
                label: "Ventes",
                href: "/admin/cash-register/sales",
                allowedRoles: ["admin", "manager"],
            },
        ],
    },
    {
        label: "E-Boutique",
        icon: <Store className="text-neutral-700 dark:text-neutral-200 h-5 w-5 flex-shrink-0" />,
        isSection: true,
        allowedRoles: ["admin", "manager"],
        isPro: true, // Mark as Pro feature
        isClickable: false, // Make it not clickable
        sublinks: [
            {
                label: "Commandes en ligne",
                href: "/admin/store/orders",
                allowedRoles: ["admin", "manager"],
            },
        ],
    },
    {
        label: "Mon stock",
        icon: <Boxes className="text-neutral-700 dark:text-neutral-200 h-5 w-5 flex-shrink-0" />,
        isSection: true,
        allowedRoles: ["admin", "manager"],
        isClickable: true,
        sublinks: [
            {
                label: "Arrivages",
                href: "/admin/stock/management",
                allowedRoles: ["admin", "manager"],
            },
            {
                label: "Inventaire",
                href: "/admin/stock/inventory",
                allowedRoles: ["admin", "manager"],
            },
            {
                label: "Fournisseurs",
                href: "/admin/stock/suppliers",
                allowedRoles: ["admin", "manager"],
            },
        ],
    },
    {
        label: "Données finances",
        icon: <Calculator className="text-neutral-700 dark:text-neutral-200 h-5 w-5 flex-shrink-0" />,
        isSection: true,
        allowedRoles: ["admin","manager"],
        isClickable: true,
        sublinks: [
            {
                label: "Données",
                href: "/admin/comptability/statistics",
                allowedRoles: ["admin","manager"], // Only admin can see statistics
            },
            {
                label: "Compta",
                href: "/admin/comptability/accounting",
                allowedRoles: ["admin","manager"], // Both admin and comptable can see accounting
            },
        ],
    },
    {
        label: "Données finances",
        icon: <Calculator className="text-neutral-700 dark:text-neutral-200 h-5 w-5 flex-shrink-0" />,
        isSection: true,
        allowedRoles: ["comptable"],
        isClickable: true,
        sublinks: [
            {
                label: "Données",
                href: "/comptable",
                allowedRoles: ["comptable"], // Only admin can see statistics
            },
            {
                label: "Compta",
                href: "/comptable/accounting",
                allowedRoles: [ "comptable" ], // Both admin and comptable can see accounting
            },
        ],
    },
    {
        label: "Utilisateurs",
        href: "/admin/users",
        icon: <Users className="text-neutral-700 dark:text-neutral-200 h-5 w-5 flex-shrink-0" />,
        allowedRoles: ["admin"],
        isClickable: true,
    },
    {
        label: "Problèmes",
        icon: <AlertCircle className="text-neutral-700 dark:text-neutral-200 h-5 w-5 flex-shrink-0" />,
        allowedRoles: ["admin", "manager"],
        isClickable: true,
        sublinks: [
            {
                label: "Problèmes",
                href: "/admin/issues/list",
                allowedRoles: ["admin"], // Only admin can see list of problems
            },
            {
                label: "Support",
                href: "/admin/issues",
                allowedRoles: ["admin", "manager"], // Both can access support
            },
        ],
    },
    {
        label: "Paramètres",
        href: "/admin/settings",
        icon: <Settings className="text-neutral-700 dark:text-neutral-200 h-5 w-5 flex-shrink-0" />,
        allowedRoles: ["admin"],
        isClickable: true,
    },
]